import { Selector } from '@ngxs/store';
import { TraceabilityState } from './traceability.state';
import { TraceabilityStateModel } from './traceability.model';

export class TraceabilitySelectors {
  @Selector([TraceabilityState])
  static recentEvents(state: TraceabilityStateModel) {
    return state.recentEvents || [];
  }

  @Selector([TraceabilityState])
  static stats(state: TraceabilityStateModel) {
    return state.stats;
  }

  @Selector([TraceabilityState])
  static history(state: TraceabilityStateModel) {
    return state.history || [];
  }

  @Selector([TraceabilityState])
  static verificationResult(state: TraceabilityStateModel) {
    return state.verificationResult;
  }

  @Selector([TraceabilityState])
  static isLoading(state: TraceabilityStateModel) {
    return !!state.isLoading;
  }

  @Selector([TraceabilityState])
  static headers(state: TraceabilityStateModel) {
    return state.headers;
  }

  @Selector([TraceabilityState])
  static pagination(state: TraceabilityStateModel) {
    return state.pagination;
  }
}
